import { Fragment, memo, ReactElement, useMemo } from 'react';

import { FieldGenerator, RenderContext, StyleVariant } from '@breathelife/field-generator';
import { RenderingFieldGroup } from '@zinnia/form-engine-sdk';

import { useCarrierContext, useLanguage } from '../../../../Hooks';
import { FieldGroupCardContainer } from './FieldGroupCard/FieldGroupCardContainer';
import { useQuestionnaireEngine } from '../../../../Hooks/useQuestionnaireEngine';
import { useViewNextIncompleteFieldContext } from '../ViewNextIncompleteFieldContext';

type FieldGroupContainerProps = {
  fieldGroup: RenderingFieldGroup;
};

const noop = () => undefined;

export const FieldGroupContainer = memo(InnerFieldGroupContainer);

export function InnerFieldGroupContainer(props: FieldGroupContainerProps): ReactElement {
  const { fieldGroup } = props;
  const { iconMap } = useCarrierContext();
  const language = useLanguage();
  const { focusedIncompleteFieldId } = useViewNextIncompleteFieldContext();

  const { questionnaireEngine } = useQuestionnaireEngine();

  const onAnswerChange = useMemo(() => {
    return questionnaireEngine.updateAnswers.bind(questionnaireEngine);
  }, [questionnaireEngine]);

  if (!fieldGroup.visible) return <Fragment />;

  if (fieldGroup.displayAsCard) {
    return <FieldGroupCardContainer fieldGroup={fieldGroup} focusedIncompleteFieldId={focusedIncompleteFieldId} />;
  }

  return (
    <FieldGenerator
      context={RenderContext.web}
      fieldGroup={fieldGroup}
      onAnswerChange={onAnswerChange}
      onAnswerComplete={noop}
      styleVariant={StyleVariant.pro}
      iconMap={iconMap}
      locale={language}
      focusedIncompleteFieldId={focusedIncompleteFieldId}
    />
  );
}
